const MILLIMETRES_PER_INCH = 25.4;
const PIXELS_PER_INCH = 96;

const PIXELS_PER_MILLIMETRE = PIXELS_PER_INCH / MILLIMETRES_PER_INCH;

export const millimetresToPixels = (millimeters: number): number =>
  millimeters * PIXELS_PER_MILLIMETRE;
